<template>
    <div class="member-center-container">
        <div class="member-center-header">
            <div class="line"></div>
            <div class="member-title">会员中心</div>
        </div>

        <!-- 会员状态提示 -->
        <div class="member-status-section">
            <div class="user-avatar">
                <img :src="userInfo.avatar" alt="用户头像" v-if="isLoggedIn">
                <img src="@/assets/images/6.png" alt="用户头像" v-else>
            </div>
            <div class="status-text">
                <div class="status-title" v-if="userInfo.is_paid_member == 1"> 专属会员标识，可续费延长</div>
                <div class="status-title" v-if="userInfo.is_paid_member == 0">您当前未开通会员</div>
                <div class="status-subtitle" v-if="userInfo.is_paid_member == 0">开通会员享更多权益</div>
                <div class="status-subtitle" v-else>有效期：{{ userInfo.paid_member_end_time }}</div>

            </div>
        </div>

        <!-- 购买VIP选项 -->
        <div class="purchase-section">
            <div class="section-title">购买VIP</div>
            <div class="vip-options">
                <div class="vip-card" :class="{ 'active': chooseAid == item.aid }"
                    v-for="(item, index) in intervalPrecision" :key="index" @click="chooseHuiyuan(item)">
                    <div class="vip-type">{{ item.validity_name }}</div>
                    <div class="vip-price">
                        <span class="current-price">¥{{ item.money }}</span>
                        <span class="original-price">¥{{ item.crossed_price }}</span>
                    </div>
                </div>
                <!-- <div class="vip-card">
                    <div class="vip-type">季卡</div>
                    <div class="vip-price">
                        <span class="current-price">¥39.9</span>
                        <span class="original-price">¥99.9</span>
                    </div>
                </div>
                <div class="vip-card">
                    <div class="vip-type">半年卡</div>
                    <div class="vip-price">
                        <span class="current-price">¥59.9</span>
                        <span class="original-price">¥189.9</span>
                    </div>
                </div>
                <div class="vip-card">
                    <div class="vip-type">年卡</div>
                    <div class="vip-price">
                        <span class="current-price">¥99.9</span>
                        <span class="original-price">¥289.9</span>
                    </div>
                </div> -->
            </div>
        </div>

        <!-- 会员权益 -->
        <div class="benefits-section">
            <div class="section-title">会员权益</div>
            <div class="benefit-item" v-html="rights"></div>
        </div>

        <!-- 立即支付按钮 -->
        <div class="payment-section">
            <el-button type="primary" size="large" class="pay-button" @click="goPay">立即支付</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MemberCenter',
    data() {
        return {
            // 这里可以添加需要的数据
            intervalPrecision: [],
            chooseAid: '',
            rights: '',
            userInfo: {}
        }
    },
    mounted() {
        this.getIntervalPrecision();
        if (this.isLoggedIn) {
            this.getUserInfo()
        }
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },

    },
    methods: {
        // 这里可以添加需要的方法，比如选择VIP类型、支付等
        getIntervalPrecision() {
            this.$api.getIntervalPrecision().then(res => {
                this.intervalPrecision = res
                this.chooseAid = this.intervalPrecision[0].aid
                this.rights = this.intervalPrecision[0].rights
            }).catch(err => {
                this.$message.error(err);
            })
        },
        chooseHuiyuan(item) {
            this.chooseAid = item.aid
            this.rights = item.rights
        },

        getUserInfo() {
            this.$api.userInfo().then(res => {
                this.userInfo = res
            }).catch(err => {
                this.$message.error(err);
            })
        },

        goPay() {
            let data = {
                product_id: this.chooseAid
            }
            this.$dapi.buyMember(data).then(res => {
                let info = res
                this.$router.push({
                    name: 'Payment', // 用 name 跳转，而非 path
                    params: {
                        time: info.last_time,
                        money: info.payable_money,
                        order_type: 3,
                        order_config_id: 15,
                        is_from: 3,
                    },
                    // 如需保留 query 参数，可加 query
                    query: { order_sn: info.order_sn, is_from: 3 }
                });
            }).catch(err => {
                this.$message.error(err);
            })
        }
    }
}
</script>

<style scoped>
.member-center-container {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 8px;
    margin: 0 auto;
}

.member-center-header {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.member-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
    padding-left: 10px;
    text-align: left;
}

.line {
    width: 3px;
    height: 18px;
    background-color: #286CED;
}

.member-status-section {
    display: flex;
    align-items: center;
    background: url(~@/assets/images/53.png) no-repeat;
    background-size: 100% auto;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 30px;
}

.status-content {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
}

.user-avatar img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.3);
}

.status-text {
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.status-title {
    font-weight: 500;
    font-size: 18px;
    color: #602B12;
    margin-bottom: 5px;
}

.status-subtitle {
    font-weight: 400;
    font-size: 16px;
    color: #946F53;
}

.status-image img {
    width: 150px;
    height: auto;
    opacity: 0.9;
}

.purchase-section {
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
}

.section-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: left;
}

.vip-options {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    width: 100%;
}

.vip-card {
    display: flex;
    flex-direction: column;
    flex: 1;
    background-color: #f9f9f9;
    border-radius: 8px;
    padding: 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px solid #e8e8e8;
}

.vip-card.active {
    background-color: #e6f2ff;
    border-color: #286CED;
    box-shadow: 0 4px 12px rgba(40, 108, 237, 0.15);
}

.vip-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.vip-type {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
}

.vip-price {
    font-size: 18px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
}

.current-price {
    color: #ff4d4f;
    margin-right: 5px;
}

.original-price {
    font-size: 12px;
    color: #999;
    text-decoration: line-through;
}

.benefits-section {
    margin-bottom: 30px;
}

.benefits-list {
    display: flex;
    flex-direction: column;
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
}

.benefit-item {
    text-align: left;
    font-size: 14px;
    color: #666;
    margin-bottom: 10px;
    position: relative;
}

.payment-section {
    display: flex;
    justify-content: flex-start;
}

.pay-button {
    width: 120px;
    height: 40px;
    font-size: 14px;
    background-color: #286CED;
    border-color: #286CED;
    border-radius: 4px;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .status-content {
        flex-direction: column;
        align-items: flex-start;
    }

    .status-text {
        margin-left: 0;
        margin-top: 15px;
    }

    .status-image {
        margin-top: 15px;
    }

    .vip-options {
        flex-direction: column;
    }

    .vip-card {
        margin-bottom: 15px;
    }
}
</style>